import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.community.edit');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

declare const tinymce: any;

@Component({
    selector: 'wiz-portal-community-edit',
template: templateSource || '',
    styles: [``],
})
export class PortalCommunityEditComponent implements OnInit, OnDestroy {

    @ViewChild('modalMessage') modalMessage: any;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

    @Input() category!: string;
    @Input() postId!: string;
    @Input() parentId: string = '';

    public post: any = {};
    public role: string | null = null;
    public status: any = {
        upload: false,
        upload_process: 0
    };

    constructor(@Inject( Router)         private router: Router,@Inject( Service    )         public service: Service    ) {}

    get title(): string {
        const category = this.post?.category || this.category;
        const map: any = {
            notice: '공지사항',
            faq: '문의사항'
        };
        return map[category] || '게시판';
    }

    async ngOnInit() {

        await this.service.init();
        this.role = this.service.auth.session?.role || null;

        const id = this.postId;

        if (id && id !== 'new') {
            const res = await wiz.call('list', { post_id: id });
            this.post = res?.data?.post || {};
        } else {
            this.post = {};
        }

        if (!this.post.id) {
            this.post.category = this.category;
            this.post.sub_category = this.category;
            this.post.priority = '0';
            this.post.content = '';
            this.post.files = [];

            if (this.parentId) {
                this.post.parent_id = parseInt(this.parentId);
            }
        } else {
            this.post.priority = String(this.post.priority);
            this.post.files = this.safeParse(this.post.files);
        }

        await this.service.render();
        this.initEditor();
    }


    private async showModal(message: string): Promise<void> {
	    await this.modalMessage.open({ message });
	}
    
    private initEditor() {

        if (tinymce.get('editor')) {
            tinymce.get('editor').remove();
        }

        tinymce.init({
            selector: '#editor',
            height: 400,
            setup: (editor: any) => {
                editor.on('init', () => {
                    editor.setContent(this.post.content || '');
                });
            }
        });
    }

    private safeParse(data: any) {
        try {
            return JSON.parse(data || '[]');
        } catch {
            return [];
        }
    }

    list() {
        this.router.navigate(['/community', this.category, 'list']);
    }

    view() {
        this.router.navigate(['/community', this.category, 'view', this.post.id]);
    }

    async update() {

        const payload = { ...this.post };

        payload.content =
            tinymce.get("editor")?.getContent() || '';

        payload.files = JSON.stringify(this.post.files || []);

        const res = await wiz.call('update', payload);

        if (res.code === 200) {
            this.router.navigate(['/community', this.category, 'list']);
        }
    }

    async deletePost() {

        const confirmed = await this.modalMessage.open({
            title: '게시글 삭제',
            message: '게시글을 삭제하면 복원할 수 없습니다. 정말 삭제하시겠습니까?',
            btnAction: '삭제',
            btnClose: '취소',
            btnClass: 'bg-[#cd201f] hover:bg-[#cd201f]/80 px-4 py-1.5'
        });

        if (!confirmed) return;

        await wiz.call('delete', { id: this.post.id });

        this.router.navigate(['/community', this.category, 'list']);
    }

    async deleteFile(file) {

        this.post.files =
            this.post.files.filter((f) => f.uri !== file.uri);

        await this.service.render();
    }

    upload() {

        const files = this.fileInput?.nativeElement?.files;
        if (!files?.length) {
            this.showModal('파일을 선택해주세요.');
            return;
        }

        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append('file[]', files[i]);
        }

        this.status.upload = true;
        this.status.upload_process = 0;
        this.service.render();

        const xhr = new XMLHttpRequest();

        xhr.upload.onprogress = (e: any) => {
            if (e.lengthComputable) {
                this.status.upload_process =
                    Math.round((e.loaded / e.total) * 10000) / 100;
                this.service.render();
            }
        };

        xhr.onreadystatechange = async () => {
            if (xhr.readyState === 4) {
                this.status.upload = false;

                if (xhr.status === 200) {
                    try {
                        const res = JSON.parse(xhr.responseText);
                        if (res.code === 200) {
                            (res.data || []).forEach((file: any) => {
                                this.post.files.push(file);
                            });
                            await this.showModal('파일이 업로드되었습니다.');
                        }
                    } catch (e) {
                        console.error('Upload response parse error:', e);
                    }
                }

                if (this.fileInput?.nativeElement) {
                    this.fileInput.nativeElement.value = '';
                }

                await this.service.render();
            }
        };

        xhr.open('POST', '/wiz/api/portal.community.edit/upload');
        xhr.send(formData);
    }

    ngOnDestroy() {
        if (tinymce.get('editor')) {
            tinymce.get('editor').remove();
        }
    }
}

export default PortalCommunityEditComponent;